<template>
  <div :class="['opc-tile', {
    'opc-tile--no-outline': !outline,
    'opc-tile-modal': $context.is.modal,
    'opc-tile-modal-2col': $context.is.modal2Column
    }]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Tile',
  props: {
    outline: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@zoom/billing-responsive/styles/responsive.scss';
@import '@/styles/scss-utils.scss';

.opc-tile {
  &.opc-tile-modal:not(.opc-tile-modal-2col) {
    padding: 24px;
  }
  @include simplifyStyle() {
    padding: 20px;
  }
}

.opc-tile {
  position: relative;
  // box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
  // border-radius: 16px;
  border-radius: 12px;
  border: 1px solid var(--zoom-color-border-neutral, #939BA4);
  background: var(--zoom-color-bg-default, #FFFFFF);
  width: 100%;
  padding: 20px;
  @include media(mobile,tablet){
    padding: 16px;
  }
  & + & {
    margin-top: 16px;
  }
  animation: fadein 0.3s normal forwards ease-in-out;
  animation-iteration-count: 1;
  animation-delay: 0s;
  // & {
  //   transition: all 0.5s ease;
  //   &:hover {
  //     transform: scale(1.015);
  //   }
  // }

  &--no-outline {
    border: none;
    border-radius: 0px;
    padding: 0;
  }
}

.opc-tile:has(.opc-foldable.is-active):has(.opc-payment-cards__group.opc-card-radio.inline-display) {
  border-radius: 0;
  border: none;
}
</style>
